import type { FilterType } from './types'

// Filter options configuration
export const FILTER_OPTIONS: { value: FilterType; label: string }[] = [
  { value: 'all', label: 'All items' },
  { value: 'journals', label: 'Journals' },
  { value: 'tasks', label: 'Tasks' },
  { value: 'library', label: 'Library' },
]
